import * as React from 'react';

import {TinyGreyCard} from 'shells/card/tiny-grey-card';
import {colors} from 'shells/colors/colors';
import {
    AccountIcon,
    AddressCardIcon,
    CheckboxIcon,
    ChevronDownIcon,
    ContactIcon,
    EmailIcon,
    FileUploadIcon,
    LongTextIcon,
    NoteIcon,
    PhoneIcon,
    RadioIcon,
    ShortTextIcon,
    CalendarIcon,
} from 'shells/icon';

import type {View, SelectFieldInput} from '../../../../types';

import styles from './add-card.module.css';

type Props = {
    personNameIsDisabled: boolean;
    companyNameIsDisabled: boolean;
    onShowPersonNamePopover: (e: React.SyntheticEvent<any>) => void;
    onShowCompanyNamePopover: (e: React.SyntheticEvent<any>) => void;
    onRemovePopover: () => void;
    nameCardText: string;
    nameCardFieldKey: string;
    onSelectInputField: (arg1: SelectFieldInput) => void;
    setCurrentView: (newView: View) => void;
};

export function FieldCards(props: Props) {
    return (
        <div className={styles['grid-container']}>
            <TinyGreyCard
                // @ts-expect-error
                icon={<ShortTextIcon fill={colors.grey} size={20} />}
                text='Short text'
                onClick={() => props.setCurrentView('short-text')}
            />
            <TinyGreyCard
                // @ts-expect-error
                icon={<LongTextIcon fill={colors.grey} size={20} />}
                text='Long text'
                onClick={() => props.setCurrentView('long-text')}
            />
            <TinyGreyCard
                isDisabled={props.personNameIsDisabled}
                onHover={props.personNameIsDisabled ? props.onShowPersonNamePopover : undefined}
                onBlur={props.personNameIsDisabled ? props.onRemovePopover : undefined}
                // @ts-expect-error
                icon={<ContactIcon fill={colors.grey} size={20} />}
                text={props.nameCardText}
                onClick={() =>
                    props.onSelectInputField({
                        fieldKey: props.nameCardFieldKey,
                        displayType: 'textfield',
                        entityType: 'Contacts',
                    })
                }
            />
            <TinyGreyCard
                isDisabled={props.companyNameIsDisabled}
                onHover={props.companyNameIsDisabled ? props.onShowCompanyNamePopover : undefined}
                onBlur={props.companyNameIsDisabled ? props.onRemovePopover : undefined}
                // @ts-expect-error
                icon={<AccountIcon fill={colors.grey} size={20} />}
                text='Company'
                onClick={() =>
                    props.onSelectInputField({
                        fieldKey: 'name',
                        displayType: 'textfield',
                        entityType: 'Accounts',
                    })
                }
            />
            <TinyGreyCard
                icon={<EmailIcon size={20} />}
                text='Email'
                onClick={() =>
                    props.onSelectInputField({
                        fieldKey: 'email',
                        displayType: 'textfield',
                        entityType: 'Contacts',
                    })
                }
            />
            <TinyGreyCard
                icon={<PhoneIcon size={20} />}
                text='Phone'
                onClick={() =>
                    props.onSelectInputField({
                        fieldKey: 'phone',
                        displayType: 'textfield',
                        entityType: 'Contacts',
                    })
                }
            />
            <TinyGreyCard
                icon={<AddressCardIcon size={20} />}
                text='Address'
                onClick={() =>
                    props.onSelectInputField({
                        fieldKey: 'address',
                        displayType: 'singleLineAddress',
                        entityType: 'Contacts',
                    })
                }
            />
            <TinyGreyCard
                icon={<NoteIcon fill={colors.grey} size={20} />}
                text='Note'
                onClick={() =>
                    props.onSelectInputField({
                        fieldKey: 'note',
                        displayType: 'textarea',
                        entityType: 'Contacts',
                    })
                }
            />
            <TinyGreyCard
                icon={<FileUploadIcon size={20} />}
                text='File upload'
                onClick={() =>
                    props.onSelectInputField({
                        fieldKey: 'file',
                        displayType: 'file',
                        entityType: 'Contacts',
                    })
                }
            />
            <TinyGreyCard
                // @ts-expect-error
                icon={<ChevronDownIcon fill={colors.grey} size={20} />}
                text='Dropdown'
                onClick={() => props.setCurrentView('dropdown')}
            />
            <TinyGreyCard
                // @ts-expect-error
                icon={<RadioIcon fill={colors.grey} size={20} />}
                text='Radio'
                onClick={() => props.setCurrentView('radio')}
            />
            <TinyGreyCard
                // @ts-expect-error
                icon={<CheckboxIcon fill={colors.grey} size={20} />}
                text='Checkbox'
                onClick={() => props.setCurrentView('checkbox')}
            />
            <TinyGreyCard
                icon={<CalendarIcon fill={colors.grey} size={20} />}
                text='Date'
                onClick={() => props.setCurrentView('date')}
            />
        </div>
    );
}
